<template>
    <el-main>
        <div style="margin-bottom: 15px; display: flex;flex-flow: row;justify-content:flex-start">
            <el-input placeholder="请输入使用单位" v-model="search" style="width: 300px" >
            </el-input>
            <el-button type="primary" plain @click="query" style="margin-left: 10px">搜索</el-button>
        </div>
        <div>
            <el-table :data="tool"  border style="width: 100%;height:50vh;" >
                <el-table-column prop="unit" label="使用单位" ></el-table-column>
                <!--                <el-table-column prop="createBy" label="创建人"></el-table-column>-->
                <el-table-column prop="liftNum" label="产品编号" ></el-table-column>
                <el-table-column prop="detectionDate" label="检测时间" >
                    <template v-slot="scope">
                        <!--   显示时间格式为年月日时分秒  <span>{{formatDate(scope.row.createDate,"yyyy-MM-dd hh:mm:ss")}}</span>-->

                        <span>{{formatDate(scope.row.createDate,"yyyy-MM-dd")}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="detailArea" label="地址" ></el-table-column>
                <el-table-column prop="orderNo" label="工单号" ></el-table-column>
<!--                <el-table-column prop="rejectDetail" label="驳回原因" ></el-table-column>-->
                <el-table-column prop="unitNum" label="单位内编码" ></el-table-column>
                <el-table-column prop="liftType" label="设备品种" ></el-table-column>
                <el-table-column prop="unitCode" label="使用单位代码" ></el-table-column>
                <el-table-column prop="contstart" label="信息状态" ></el-table-column>
                <el-table-column label="操作">
                    <template v-slot="scope">
                        <el-button  type="primary" plain size="small" @click="check(scope.row)" >点击检测</el-button>

                    </template>
                </el-table-column>

            </el-table>
        </div>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>
    </el-main>
</template>

<script>
    import request from "../../util/request";
    export default {
        // eslint-disable-next-line vue/multi-word-component-names
        name: "startDetect",
        data(){
            return{
                items: ['未检测', '执行中'], //, '已完成'
                current: 0,
                messageResu: '', //驳回原因
                currentPage: 1, //未检测的当前页
                pageSize: 20, //未检测的展示的数量
                total: 50, //未检测的总数
                cpage: 1, //检测中的当前页
                Size: 20, //检测中的展示的数量
                recordTotal: 50, //检测中的总数
                ordertotal: 50, //未检测的总数
                search: '',
                userName:'',
                reSave: "",
                detectionDate: '',
                messageText: '正在处理...',
                orderAreaDevices: [], //展示已分页的未检测的工单
                orderlist: [], //未分页的未检测的工单
                type: 'center',
                msgType: '',
                templateList: [],
                templateId: -1,
                orderAreaDevice: {},
                recordorder: [], //初检测的工单
                recordorderList: [], //未分页的初检测的工单
                records: [], //记录
                neworderlist:[],
                testTime: [], //检测的时间
                orderID: -1,
                isabled: false,
                count: 0, //用于防止重复点击
                startlist: [], //用于未检测判断是否展开内容
                againlist: [], //用于检测中判断是否展开内容
                notMore: true, //是否无更多
                showNothing: false, //无数据
                ticketlist :[],
                item:[],
                record:[],

            }
        },
        created() {
            this.toload();
        },
        mounted(){
            console.log(this.$refs)
        },
        methods:{
            query() {
                this.reSave = this.search;
                this.toload(1);
            },
            //时间格式
            formatDate(value, fmt) {
                if (value == null || value == '') {
                    return ""
                }
                let getDate = new Date(value);
                let o = {
                    'M+': getDate.getMonth() + 1,
                    'd+': getDate.getDate(),
                    'h+': getDate.getHours(),
                    'm+': getDate.getMinutes(),
                    's+': getDate.getSeconds(),
                    'q+': Math.floor((getDate.getMonth() + 3) / 3),
                    'S': getDate.getMilliseconds()
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
                }
                for (let k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) {
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                    }
                }
                return fmt;
            },
            toload() {
                this.userName = sessionStorage.getItem('userName') .replace(/"/g, '');
                let Map = {
                  "unit":this.search,
                    "userName": this.userName
                }
                request.post ( '/detection/orderAreaDevices',Map).then( res => {

                    this.records = [];
                    this.ticketlist = [];
                    console.log(res.data)
                    if (res.data === null || res.data === "" || res.data === undefined) {
                        this.$message.error( '无数据' )
                        return
                    }

                    this.records = res.data.records;
                    this.testTime = JSON.parse(JSON.stringify(this.records));
                    let pass = res.data.pass;
                    let orderAreaDevices = res.data.orderAreaDevices;
                    const ids = this.records.map(e => e.orderId);//初检中所有工单id

                    let filtered = [];
                    for (let i = 0; i < orderAreaDevices.length; i++) {
                        for (let j = 0; j < ids.length; j++) {
                            if (ids[j] == orderAreaDevices[i].orderId) {
                                filtered.push(orderAreaDevices[i]);//初检检测中的数据集
                            }
                        }

                    }
                    let list = JSON.parse(JSON.stringify(this.records));
                    for (let i = 0; i < pass.length; i++) {
                        list.push(pass[i]);
                    }
                    const orderIds = list.map(e => e.orderId);//全部检测的工单id
                    let orders = orderAreaDevices.filter(e => !orderIds.includes(e.orderId));//未检测的数据集

                    this.orderlist = orders;//未检测
                    this.ordertotal = orders.length;
                    this.recordorderList = filtered;//检测中
                    this.recordTotal = filtered.length;
                    for(let i = 0; i < this.orderlist.length; i++){
                        this.orderlist[i].contstart = "未检测";
                        this.ticketlist.push(this.orderlist[i]);
                    }
                    for ( let i = 0; i < this.recordorderList.length; i++){
                        this.recordorderList[i].contstart = "检测中";
                        this.ticketlist.push(this.recordorderList[i]);
                    }
                    console.log(this.ticketlist)
                    this.total = this.ticketlist.length;//数据及长度
                    this.getPageInfo();


                } )
            },
            remoreinfo() {
                sessionStorage.removeItem('Record');
                sessionStorage.removeItem('orderAreaDevice');
                sessionStorage.removeItem('vDeviceArea');
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.currentPage = val
                this.getPageInfo()
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.pageSize = val
                this.getPageInfo()
            },
            getPageInfo() {
                //清空pageTicket中的数据
                this.tool = [];
                // 获取当前页的数据
                for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
                    //把遍历的数据添加到pageTicket里面
                    this.tool.push(this.ticketlist[i]);
                    //判断是否达到一页的要求
                    if (this.tool.length === this.pageSize) break;
                }
            },
            dialogConfirm() {
                let Map = {
                    templateId: this.templateId,
                    userName: this.orderAreaDevice.userName,
                    userAlias: this.orderAreaDevice.userAlias,
                    orderId: this.orderAreaDevice.orderId,
                    liftId: this.orderAreaDevice.liftId,
                    name: sessionStorage.getItem('userName') .replace(/"/g, '')
                }
                if (this.templateId != -1) {
                    request.post ( '/detection/addRecord', Map).then( res => {
                            this.isabled = false; //允许点击
                            this.count = 0;
                            this.remoreinfo();
                            let item = JSON.stringify(res.data)
                        console.log('插入数据之后输出res')
                        console.log(res.data)
                        sessionStorage.setItem('Record', item);
                        let orderAreaDevice = JSON.stringify(this.orderAreaDevice)
                        sessionStorage.setItem('orderAreaDevice', orderAreaDevice);

                        this.$router.push({path:'infoDetection', query:{}})
                        },
                    )
                } else {
                    this.$message.error( '未找到对应的模板' )
                }
            },

            check(item){
                if (item.contstart == "未检测"){
                    this.msgType = this.type
                    this.count++;
                    if (this.count >= 2) {

                        this.$refs.message.open();
                        return
                    }
                    this.isabled = true; //禁止点击
                    this.orderAreaDevice = item;
                    this.detectionDate = this.formatDate(new Date(), "yyyy-MM-dd");
                    this.orderID = item.orderId;
                    console.log(this.orderAreaDevice.liftId )
                    //查询模板
                    request.get( '/detection/queryTemplate',{
                        params: {
                            lifeId: this.orderAreaDevice.liftId
                        }
                    } ).then( res => {
                        if (res.code === '0') {
                            this.templateId = res.data.templateId;
                            console.log('查模板插入数据表')
                             this.dialogConfirm()
                        } else {
                            this.$message.error( '无该类别模板' )
                            return
                        }
                    })
                }

                for (var j = 0; j < this.records.length; j++) {
                    if (this.records[j].orderId === item.orderId) {
                        this.record = this.records[j];
                    }
                }
                this.remoreinfo();
                sessionStorage.setItem('Record', JSON.stringify(this.record))
                let orderAreaDevice = JSON.stringify(item)
                sessionStorage.setItem('orderAreaDevice', orderAreaDevice)
                this.$router.push({path:'infoDetection', query:{}})

            },

        }



    }
</script>

<style scoped>

</style>